import { render, staticRenderFns } from "./companies-page.vue?vue&type=template&id=1db531e8&scoped=true&"
import script from "./companies-page.vue?vue&type=script&lang=js&"
export * from "./companies-page.vue?vue&type=script&lang=js&"
import style0 from "./companies-page.vue?vue&type=style&index=0&id=1db531e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db531e8",
  null
  
)

export default component.exports